import styled from "@emotion/styled";

export const Placeholder = styled.div`
  inline-size: 194px;
  block-size: 42px;
`;
